import { ApplicationVersion } from 'models/application-version.model';
import { Base, PageObject } from '@testsigmainc/models';
import { User } from '@models/user.model';
import { custom, deserialize, object, serializable } from 'serializr';
import { RequirementType } from './requirement-type.model';

export class Requirement extends Base implements PageObject {
  @serializable
  public applicationVersionId: number;
  @serializable
  public requirementName: string;
  @serializable(
    custom(
      (v) => {
        if (v) return JSON.stringify(v);
      },
      (v) => {
        if (v && typeof v == 'string') return JSON.parse(v);
        else if (v) return v;
      },
    ),
  )
  public customFields: Object;
  @serializable
  public createdById: number;
  @serializable
  public updatedById: number;
  @serializable
  public requirementDescription: string;
  @serializable
  public requirementTypeId: number;
  @serializable
  public type: string;
  @serializable
  public plannedManualCount: number;
  @serializable
  public plannedAutomationCount: number;
  @serializable(object(RequirementType))
  public requirementType: RequirementType;

  public createdBy: User;
  public updatedBy: User;
  public isSelected: boolean;
  @serializable(object(ApplicationVersion))
  public version: ApplicationVersion;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Requirement, input));
  }
}
